import { isMobileNative, getDevicePlatform, IOS_DEVICE } from "util/device";
import * as config from "util/config";

const getFingerprintVU = () =>
    new Promise((onSuccess, onError) => {
        if (!isMobileNative) {
            const url = config.get("fraud.vu.passiveFingerprintEndpointURL");
            const time = config.getInteger("fraud.vu.passiveFingerprintTimeOutInMilliseconds", 10000);

            window.BrowserFP.getFingerprintInfo(url, time).then(
                (result) => {
                    onSuccess(result);
                },
                (msg) => {
                    onError(msg);
                },
            );
        } else {
            window.vuFraudPrevention.getHash().then(
                (result) => {
                    onSuccess(result);
                },
                (msg) => {
                    onError(msg);
                },
            );
        }
    });

const getFingerprintDeviceInfoVU = () => {
    if (isMobileNative) {
        return new Promise((onSuccess, onError) => {
            window.vuFraudPrevention.getFingerprintInfo().then(
                (result) => {
                    let data = {};
                    if (result !== null) {
                        const resultaData = getDevicePlatform() !== IOS_DEVICE ? JSON.parse(result) : result;

                        data = {
                            ...resultaData,
                            rooted: resultaData.rooted === "YES" ? "true" : "false",
                            fingerprintCompatible: resultaData.fingerprintCompatible === "YES" ? "true" : "false",
                            gpsCompatible: resultaData.gpsCompatible === "YES" ? "true" : "false",
                        };
                    }
                    onSuccess(data);
                },
                (msg) => {
                    onError(msg);
                },
            );
        });
    }
    return null;
};

const getRandomSeed = () => {
    if (isMobileNative) {
        return new Promise((onSuccess, onError) => {
            window.vuFraudPrevention.getRandomSeed().then(
                (result) => {
                    onSuccess(result);
                },
                (msg) => {
                    onError(msg);
                },
            );
        });
    }
    return null;
};

const getDeviceLocation = () => {
    if (isMobileNative) {
        return new Promise((onSuccess, onError) => {
            window.vuFraudPrevention.getDeviceLocation().then(
                (result) => {
                    onSuccess(result);
                },
                (msg) => {
                    onError(msg);
                },
            );
        });
    }
    return null;
};

const getFingerPrintData = () =>
    new Promise((onSuccess, onError) => {
        const fingerPrint = config.getBoolean("fraud.vu.fingerprint.active", false);
        if (!fingerPrint) {
            onSuccess(null);
        } else {
            let promises = [getFingerprintVU()];
            if (isMobileNative) {
                promises = [...promises, getRandomSeed(), getDeviceLocation(), getFingerprintDeviceInfoVU()];
            }

            Promise.all(promises)
                .then((values) => {
                    const data = {
                        apikey: null,
                        userid: null,
                        fingerprint: values[0],
                        randomSeed: values[1],
                        deviceLocation: values[2],
                        deviceFingerprintData: values[3],
                    };
                    onSuccess(data);
                })
                .catch((err) => onError(err));
        }
    });

export default getFingerPrintData;
